"use client";

import { motion, AnimatePresence } from "framer-motion";
import { useEffect, useState } from "react";

import season12 from "../Assets/season1/2.jpg";
import season13 from "../Assets/season1/3.jpg";
import season14 from "../Assets/season1/4.jpg";
import season15 from "../Assets/season1/5.jpg";
import testing from "../Assets/season1/AGKC.jpg";
import award from "../Assets/season1/Award.jpeg";

import cul1 from "../Assets/season1/cul2.JPG"
import cul2 from "../Assets/season1/cultural.JPG"

import trac1 from "../Assets/season1/trac2.JPG"
import trac2 from "../Assets/season1/traction.JPG"

import ti from "../Assets/season1/TI.JPG"

import ing from "../Assets/season1/ING.JPG"

import brk from "../Assets/season1/break.JPG"

import end from "../Assets/season1/endu.JPG"

import season21 from "../Assets/season2/1.jpg";
import season22 from "../Assets/season2/2.JPG";
import season24 from "../Assets/season2/4.jpg";
import season25 from "../Assets/season2/5.jpg";
import season26 from "../Assets/season2/6.jpg";
import season27 from "../Assets/season2/7.jpg";
import evtest from "../Assets/season2/8.jpg";
import rider from "../Assets/season2/10.jpg";
import endurance from "../Assets/season2/12.jpg";

import aw from "../Assets/season2/awd.JPG"
import cm from "../Assets/season2/cm2.jpg"
import dm from "../Assets/season2/dm1.jpg"
import drv from "../Assets/season2/drv1.JPG"
import end1 from "../Assets/season2/end.JPG"
import ev2 from "../Assets/season2/ev2.JPG"
import ing1 from "../Assets/season2/ingral.JPG"
import man from "../Assets/season2/manv.JPG"
import TI from "../Assets/season2/TI1.jpg"

import "./Gallery.css";

const seasonData = {
  season2: [
    { id: 1, title: "Inaugural Ceremony", imgs: [season21, ing1] },
    { id: 2, title: "Captains Meet", imgs: [season22, cm] },
    { id: 3, title: "Drivers Meet", imgs: [rider, dm,drv] },
    { id: 4, title: "TI Qualification Test", imgs: [season24,TI] },
    { id: 5, title: "Testing Zone", imgs: [season25, evtest,ev2] },
    // { id: 6, title: "EV Testing Zone", imgs: [evtest, endurance] },
    { id: 7, title: "Maneuverability", imgs: [season27,man] },
    { id: 8, title: "Endurance", imgs: [endurance, end1] },
    { id: 9, title: "Award Ceremony", imgs: [season26, aw] }
  ],

  season1: [
    { id: 1, title: "Inaugural Ceremony", imgs: [season12, ing] },
    { id: 2, title: "TI Qualify Test", imgs: [testing, ti] },
    { id: 3, title: "Brake Test", imgs: [season15, brk] },
    { id: 4, title: "Testing Zone", imgs: [season14] },
    { id: 5, title: "Endurance", imgs: [season13, end] },
    { id: 6, title: "Champions", imgs: [award] },
    { id: 7, title: "Culturals", imgs: [cul1, cul2] },
     { id: 8, title: "Traction", imgs: [trac1, trac2] },
    
  ]
};

export default function Gallery() {
  const [season, setSeason] = useState("season2");

  const items = seasonData[season];
  const [indexes, setIndexes] = useState([]);

  useEffect(() => {
    if (items && items.length > 0) {
      setIndexes(items.map(() => 0));
    }
  }, [season]);

  useEffect(() => {
    if (!items || items.length === 0) return;

    const interval = setInterval(() => {
      setIndexes(prev =>
        prev.map((idx, i) =>
          items[i] ? (idx + 1) % items[i].imgs.length : 0
        )
      );
    }, 4000);

    return () => clearInterval(interval);
  }, [items]);

  const dissolve = {
    initial: { opacity: 0, scale: 1.05, filter: "blur(6px)" },
    animate: { opacity: 1, scale: 1, filter: "blur(0px)" },
    exit: { opacity: 0, scale: 0.95, filter: "blur(6px)" }
  };

  return (
    <section className="gallery-container" id="gallery">
      <h2 className="section-title">Gallery</h2>

      <div className="season-buttons">
        <button
          className={season === "season2" ? "active" : ""}
          onClick={() => setSeason("season2")}
        >
          Season 2
        </button>

        <button
          className={season === "season1" ? "active" : ""}
          onClick={() => setSeason("season1")}
        >
          Season 1
        </button>
      </div>

      <div className="gallery-grid">
        {items.map((card, i) => (
          <div key={card.id} className="gallery-card">
            <AnimatePresence mode="wait">
              <motion.img
                key={indexes[i]}
                src={card.imgs[indexes[i]]}
                alt={card.title}
                className="gallery-img"
                variants={dissolve}
                initial="initial"
                animate="animate"
                exit="exit"
                transition={{ duration: 1 }}
              />
            </AnimatePresence>

            <div className="card-overlay">
              <h3>{card.title}</h3>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
